import React from "react";
import { SimpleLinePlusIcon } from "modules/icons";
import useStyles from "./styles";

export const AddIcon: React.FC = () => {
  const { classes } = useStyles();

  return <SimpleLinePlusIcon className={classes.icon} />;
};
